/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';

import { externalLogin } from 'apis/hcp/users.api';
import ErrorFallback from 'components/error-fallback';
import FullscreenSpinner from 'components/fullscreen-spinner';
import useGetMe from 'middleware/accounts/user/useGetMe';
import { ErrorSeverity, handleError } from 'services/errorService';
import { getSession } from 'utils/storage';

const ExternalRoute = ({ children }: { children: JSX.Element }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isPending, error } = useGetMe();
  const userError: any = error;

  const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
  const authToken = urlParams.get('auth-token');
  const service = urlParams.get('service');
  const region = urlParams.get('region') || '';
  const validateAuthetication = async (
    authToken: string | null,
    service: string | null,
    region: string | ''
  ) => {
    try {
      if (authToken) {
        externalLogin(authToken, service, region);
      } else {
        if (!localStorage.getItem('session')) {
          window.location.replace('/signin');
        }
      }
    } catch (error) {
      handleError(error, ErrorSeverity.CRITICAL, {
        source: 'ExternalRoute',
        operation: 'external authentication',
        userMessage: t('wrong-login'),
      });
      navigate('/signin', { replace: true });
    }
  };

  useEffect(() => {
    validateAuthetication(authToken, service, region);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, service, region]);

  if (
    !isPending &&
    error &&
    !(
      userError?.response?.data?.message?.includes('Expired Token') ||
      userError?.response?.data?.status === 'Forbidden Access' ||
      userError?.response?.data?.status === 'Unauthorised'
    )
  )
    return <ErrorFallback error={error} errorText={t('server-error')} />;

  if (isPending) return <FullscreenSpinner />;

  if (!getSession()) return <Navigate replace to="/signin" />;

  return children;
};

export default ExternalRoute;
